import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheBorder} from "../../TheBorder";
import {TheBorderGameMode} from "../../server/TheBorderGameMode";
import {gsap, TimelineMax} from "gsap";

/**
 * Created by Jerker Nord on 2022-04-01.
 */

export class TheBorderTotalWinRunner implements SimplePresentation {

    private _mainTL: TimelineMax;
    private _controller: SimplePresentationRunnerController;

    constructor() {
    }

    public shouldRun(): boolean {
        return (TheBorderGameMode.isEndOfAvalanche(TheBorder.model.gameData.mode, TheBorder.model.gameData.nextMode)
            && TheBorder.model.winRatio < this.getBigWinRatio() && TheBorder.model.gameData.accumulatedRoundWin > 0
            && !(TheBorder.model.data.mode == TheBorderGameMode.SUPER_FREESPIN_AVALANCHE && TheBorder.model.data.nextMode == TheBorderGameMode.NORMAL)
            && !(TheBorder.model.data.mode == TheBorderGameMode.FREESPIN_AVALANCHE && TheBorder.model.data.nextMode == TheBorderGameMode.NORMAL)
        );
    }

    private getBigWinRatio():number {
        if(TheBorder.model.data.mode == TheBorderGameMode.SUPER_FREESPIN_AVALANCHE) {
            return 100;
        }
        return 15;
    }


    public start(controller: SimplePresentationRunnerController): void {
        this._controller = controller;
        const delayTL: gsap.core.Timeline = new gsap.core.Timeline({delay: 0.35});
        let winAmount:number = TheBorder.model.gameData.accumulatedRoundWin;
        if (TheBorder.model.data.mode == TheBorderGameMode.FREESPIN_AVALANCHE ||TheBorder.model.data.mode == TheBorderGameMode.SUPER_FREESPIN_AVALANCHE){
            winAmount = TheBorder.model.gameData.totalSpinRoundWinnings;
        }
        delayTL.add(() => {
            this._mainTL = gsap.timeline({
                onComplete: () => {
                    this.complete();
                }
            });
            if (winAmount > 0){
                this._mainTL.add([
                    TheBorder.totalWinView.getTotalWinTimeline(winAmount),
                    () => this._controller.setSkipCallback(() => this.skip())
                ]);
            }
        });
    }

    private skip(): void {
        TheBorder.totalWinView.hardAbort();
    }

    private complete(): void {
        this._controller.finish();
    }
}